import React from "react";
import { Phone, Mail, MapPin, Send } from "lucide-react";
import wp1 from "../assets/contact1.jpg";
import wp2 from "../assets/home10.jpg";

const Contact = () => {
  return (
    <div className="bg-white overflow-hidden">

      {/* ================= HERO ================= */}
      <section 
        className="relative h-[65vh] flex items-center"
        style={{
          backgroundImage: `url(${wp1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
          <span className="text-amber-400 tracking-[0.4em] uppercase text-sm">
            Contact Us
          </span>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mt-4">
            Let’s Make Your <span className="text-amber-400">Home Leak-Free</span>
          </h1>
          <p className="text-gray-200 mt-6 max-w-2xl mx-auto text-lg">
            Book a free inspection with India’s trusted waterproofing experts.
          </p>
        </div>
      </section>

      {/* ================= CONTACT CARD ================= */}
      <section className="-mt-20 relative z-20 max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 bg-white rounded-3xl shadow-2xl overflow-hidden">

         {/* IMAGE SIDE */}
<div className="hidden md:block relative overflow-hidden">
  <img
              src="https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=1200&q=80"
              className="w-full h-full object-cover"
              alt="Studio"
            />
  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
  <div className="absolute bottom-8 left-8 text-white">
    <h3 className="text-2xl font-semibold">Visit Our Office</h3>
    <p className="text-sm text-gray-300 flex items-center gap-2 mt-2">
      <MapPin size={16} className="text-amber-400"/> New Delhi, India
    </p>
  </div>
</div>


          {/* FORM SIDE */}
          <div className="p-10 md:p-14">
            <h2 className="text-3xl font-bold mb-2 font-serif ">
              Book Free Inspection
            </h2>
            <div className="w-20 h-[3px] bg-amber-500 mb-8" />

            <form className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <input className="contact-input" placeholder="Full Name" />
                <input className="contact-input" placeholder="Phone Number" />
              </div>
              <input className="contact-input" placeholder="Email Address" />
              <textarea 
                rows={3} 
                className="contact-input resize-none" 
                placeholder="Describe your problem (leakage, damp wall, etc.)"
              />
              <button className="
                w-full mt-4 
                bg-gradient-to-r from-amber-500 to-amber-700 
                text-white py-4 rounded-full 
                font-semibold tracking-widest uppercase
                shadow-lg hover:scale-105 transition
                flex items-center justify-center gap-3
              ">
                Send Request <Send size={18} />
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* ================= INFO STRIP ================= */}
      <section className="max-w-6xl mx-auto px-6 py-24">
        <div className="grid md:grid-cols-3 gap-10 text-center">
          
          <div className="info-card">
            <Phone className="icon" />
            <h4>Call Us</h4>
            <p>+91 7291832000</p>
            <span>Mon–Sat | 9AM–7PM</span>
          </div>

          <div className="info-card">
            <Mail className="icon" />
            <h4>Email</h4>
            <p>hello@luxuriyahomes.com</p>
            <span>Quick Response</span>
          </div>

          <div className="info-card">
            <MapPin className="icon" />
            <h4>Office</h4>
            <p>New Delhi</p>
            <span>India</span>
          </div>

        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="bg-amber-50 py-24 text-center">
  <h2 className="text-4xl md:text-5xl font-serif font-bold text-amber-700 mb-4">
    100% Free Site Visit
  </h2>
  <p className="text-gray-700 max-w-xl mx-auto mb-8">
    No charges. No obligation. Just expert advice.
  </p>
  
  {/* ✅ Updated Call Now button with tel: link */}
  <a 
    href="tel:+917291832000" 
    className="
      inline-flex
      px-10 py-4 rounded-full
      bg-gradient-to-r from-amber-500 to-amber-700
      text-white font-semibold
      shadow-lg hover:scale-105 transition
      items-center justify-center
    "
  >
    Call Now
  </a>
</section>


      {/* ================= STYLES ================= */}
      <style>{`
        .contact-input {
          width: 100%;
          border: 1px solid #e5e7eb;
          padding: 14px 18px;
          border-radius: 999px;
          outline: none;
          transition: 0.3s;
        }
        .contact-input:focus {
          border-color: #f59e0b;
          box-shadow: 0 0 0 2px rgba(245,158,11,0.2);
        }

        .info-card {
          background: white;
          border-radius: 20px;
          padding: 40px;
          box-shadow: 0 25px 50px rgba(0,0,0,0.08);
          transition: 0.4s;
        }
        .info-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 40px 80px rgba(0,0,0,0.15);
        }
        .info-card h4 {
          font-weight: 600;
          margin-top: 10px;
        }
        .info-card p {
          font-weight: bold;
          margin-top: 4px;
        }
        .info-card span {
          font-size: 12px;
          color: #6b7280;
        }
        .info-card .icon {
          color: #f59e0b;
        }
      `}</style>
    </div>
  );
};

export default Contact;
